module.exports = __webpack_public_path__ + "assets/images/artist2.5994f0de.jpg";